//langauge codes
export const languages = [
{language:"Afrikaans",
key:"af"},
{language:"Albanian",
key:"sq"},
{language:"Amharic",
key:"am"},
{language:"Arabic",
key:"ar"},
{language:"Armenian",
key:"hy"},
{language:"Azerbaijani",
key:"az"},
{language:"Bengali",
key:"bn"},
{language:"Bosnian",
key:"bs"},
{language:"Bulgarian",
key:"bg"},
{language:"Catalan",
key:"ca"},
{language:"Chinese (Simplified)",
key:"zh"},
{language:"Chinese (Traditional)",
key:"zh-TW"},
{language:"Croatian",
key:"hr"},
{language:"Czech",
key:"cs"},
{language:"Danish",
key:"da"},
{language:"Dari",
key:"fa-AF"},
{language:"Dutch",
key:"nl"},
{language:"English",
key:"en"},
{language:"Estonian",
key:"et"},
{language:"Farsi (Persian)",
key:"fa"},
{language:"Filipino, Tagalog",
key:"tl"},
{language:"Finnish",
key:"fi"},
{language:"French",
key:"fr"},
{language:"French (Canada)",
key:"fr-CA"},
{language:"Georgian",
key:"ka"},
{language:"German",
key:"de"},
{language:"Greek",
key:"el"},
{language:"Gujarati",
key:"gu"},
{language:"Haitian Creole",
key:"ht"},
{language:"Hausa",
key:"ha"},
{language:"Hebrew",
key:"he"},
{language:"Hindi",
key:"hi"},
{language:"Hungarian",
key:"hu"},
{language:"Icelandic",
key:"is"},
{language:"Indonesian",
key:"id"},
{language:"Irish",
key:"ga"},
{language:"Italian",
key:"it"},
{language:"Japanese",
key:"ja"},
{language:"Kannada",
key:"kn"},
{language:"Kazakh",
key:"kk"},
{language:"Korean",
key:"ko"},
{language:"Latvian",
key:"lv"},
{language:"Lithuanian",
key:"lt"},
{language:"Macedonian",
key:"mk"},
{language:"Malay",
key:"ms"},
{language:"Malayalam",
key:"ml"},
{language:"Maltese",
key:"mt"},
{language:"Marathi",
key:"mr"},
{language:"Mongolian",
key:"mn"},
{language:"Norwegian (Bokmål)",
key:"no"},
{language:"Pashto",
key:"ps"},
{language:"Polish",
key:"pl"},
{language:"Portuguese (Brazil)",
key:"pt"},
{language:"Portuguese (Portugal)",
key:"pt-PT"},
{language:"Punjabi",
key:"pa"},
{language:"Romanian",
key:"ro"},
{language:"Russian",
key:"ru"},
{language:"Serbian",
key:"sr"},
{language:"Sinhala",
key:"si"},
{language:"Slovak",
key:"sk"},
{language:"Slovenian",
key:"sl"},
{language:"Somali",
key:"so"},
{language:"Spanish",
key:"es"},
{language:"Spanish (Mexico)",
key:"es-MX"},
{language:"Swahili",
key:"sw"},
{language:"Swedish",
key:"sv"},
{language:"Tamil",
key:"ta"},
{language:"Telugu",
key:"te"},
{language:"Thai",
key:"th"},
{language:"Turkish",
key:"tr"},
{language:"Ukrainian",
key:"uk"},
{language:"Urdu",
key:"ur"},
{language:"Uzbek",
key:"uz"},
{language:"Vietnamese",
key:"vi"},
{language:"Welsh",
key:"cy"},
];

export const languageKeys = languages.map(item => item.key);